import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";
import { ISolicitudVehiculoModel } from "../../interfaces/solicitud/ISolicitudVehiculoModel";
import { ISolicitudVehiculoAsignarDocumentoModel } from "../../interfaces/solicitud/vehiculos/ISolicitudVehiculoAsignarDocumentoModel";

export class SolicitudVehiculoAsignarDocumentoModel implements ISolicitudVehiculoAsignarDocumentoModel {
    vehiculos: ISolicitudVehiculoModel[];
    documento?: ISolicitudDocumentoModel;

    constructor(){
        this.vehiculos = new Array<ISolicitudVehiculoModel>();
    }
}